module.exports = __webpack_public_path__ + "assets/img/1961591928118_.pic_hd.0de23e31.jpg";